import { Heading, HFlow, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { InfoIcon } from 'components/InfoIcon'
import React from 'react'
import Permissions from 'types/Permissions'

import EquipeEMultiVinculacoesTable from './equipe-emulti/EquipeEMultiVinculacoesTable'
import VinculacoesEstabelecimentosTable from './estabelecimento/list/VinculacoesEstabelecimentosTable'

export const SERVICOS_REFERENCIA_PATH = '/servicosreferencia'

export function ServicosReferenciaView() {
  return (
    <CheckPermission permission={Permissions.configuracaoMunicipal}>
      <Heading level={2} style={{ paddingBottom: '1em' }}>
        <HFlow alignItems='center' hSpacing={0.5}>
          Serviços de referência
          <InfoIcon
            icon='infoCircleFilled'
            text='Estabelece e gerencia vínculos entre os serviços de referência especializados e atenção primária, permitindo o
          compartilhamento de cuidado entre unidades através do atendimento individual.'
          />
        </HFlow>
      </Heading>

      <VFlow vSpacing={2}>
        <VFlow vSpacing={0.5}>
          <Heading level={3}>Unidades de saúde vinculadas</Heading>
          <VinculacoesEstabelecimentosTable />
        </VFlow>
        <VFlow vSpacing={0.5}>
          <Heading level={3}>Equipes eMulti/multiprofissionais</Heading>
          <EquipeEMultiVinculacoesTable />
        </VFlow>
      </VFlow>
    </CheckPermission>
  )
}
